import { PerformanceExportService } from './performance-export-service';
import { PerformanceMenuService } from './performance-menu.service';
import { ReviewService } from './review.service';
import { SurveyMenuService, SurveyModuleMenuService } from './survey-menu.service';
import { SurveyService } from './survey.service';
import { FeedbackIndexTable } from './tables/feedback-table/feedback-index.table';
import { GoalIndexTable } from './tables/goal-table/goal-index.table';
import { ReviewIndexTable } from './tables/review-table/review-index.table';
import { SurveyIndexTable } from './tables/survey-table/survey-index.table';

const Services = [
    ReviewService,
    SurveyService,
    SurveyMenuService,
    ReviewIndexTable,
    GoalIndexTable,
    FeedbackIndexTable,
    SurveyIndexTable,
    PerformanceExportService,
    PerformanceMenuService,
    SurveyModuleMenuService,
];

export {
    FeedbackIndexTable,
    GoalIndexTable,
    PerformanceExportService,
    PerformanceMenuService,
    ReviewIndexTable,
    ReviewService,
    Services,
    SurveyIndexTable,
    SurveyMenuService,
    SurveyModuleMenuService,
    SurveyService,
};
